import { Cell, Pie, PieChart, Tooltip } from "recharts";

const COLORS = ["#412acd", "#972acd", "#2abacd", "#4dcd2a"];

const Chart = ({ chartData, title }) => {
  return (
    <div className="flex flex-col items-center">
      {chartData && (
        <>
          {title && (
            <h2 className="mt-4 mb-2 text-center text-lg font-semibold">
              {title}
            </h2>
          )}
          <PieChart width={300} height={300}>
            <Pie
              dataKey="value"
              data={chartData}
              cx="50%"
              cy="50%"
              outerRadius={80}
              fill="#8884d8"
              label
            >
              {chartData.map((entry, index) => (
                <Cell
                  key={`cell-${entry.name}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
          <div className="mt-2 flex flex-col items-start gap-2">
            {chartData.map((entry, index) => (
              <div
                key={`legend-${entry.name}`}
                className="flex items-center gap-2"
              >
                <span
                  className="inline-block h-4 w-4 rounded"
                  style={{ backgroundColor: COLORS[index % COLORS.length] }}
                ></span>
                <span className="text-sm font-medium">
                  {entry.name}: {entry.value}
                </span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Chart;
